import axios from '@/api/$axios'
export default {
  checkStar ({ collection, resourceId }) {
    return axios.get(`/${collection}s/${resourceId}/star`)
  },
  addStar ({ collection, resourceId }) {
    return axios.post(`/${collection}s/${resourceId}/star`)
  },
  deleteStar ({ collection, resourceId }) {
    return axios.delete(`/${collection}s/${resourceId}/star`)
  },
  list ({ collection, kw, page, perPage }) {
    return axios.get(`/${collection}/stared`, {
      params: { title: kw, page, perPage }
    })
  }
}
